var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"bg-image",style:(`background-image: url(${_vm.publicPath}bg.jpg)`)},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }